import {
  NgbAccordion,
  NgbModal,
  NgbModalRef,
  NgbNavChangeEvent,
} from "@ng-bootstrap/ng-bootstrap";
import {
  NgbdSortableHeader,
  SortEvent,
} from "../../../../shared/directives/NgbdSortableHeader";
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import { Router } from "@angular/router";
import jsPDF from "jspdf";
import { Utils } from "../../../../shared/utils/Utils";
import {
  Contrato,
  ContratosService,
} from "../../../../shared/services/contrato.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ObjetosContratosService } from "../../../../shared/services/objetos_contratos.service";
import { EmpresasService } from "../../../../shared/services/empresas.service";
import { DataService } from "../../../../shared/services/municipios.service";
import * as QRCode from "qrcode";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
const Swal = require("sweetalert2");

@Component({
  selector: "app-contratos",
  templateUrl: "./contratos.component.html",
  styleUrls: ["./contratos.component.scss"],
})
export class ContratosComponent {
  public selected = [];
  public searchText: string = ""; // Texto de búsqueda
  selectedEstado: any;
  vehicles: any[] = [];

  activePanelmodel: string[] = ["static-1"];
  sortDirection: string = "asc"; // 'asc' o 'desc'
  searchTerm: string = "";
  dropdownStates: boolean[] = [];
  filteredTableItems!: Contrato[];
  contratos: Contrato[] = [];
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  formContrato!: FormGroup;
  editMode!: boolean;
  modalContratoRef!: NgbModalRef;
  objetos: any;
  hoy: string = "";
  empresas: any;
  empresaSeleccionada: string | null = null;
  empresaMostrada: any = null;
  contratoMostrado: Contrato | null = null;
  formPlanilla!: FormGroup;
  municipios!: any[];
  contratoSeleccionado: any = null;
  validate: boolean = false;
  maxDate!: string;
  minDate!: string;
  fechaMinimaFinal: string = ""; // Para el campo 'fin'
  fechaMaxima: string | null = null;
  minFechaFinal: string = "";
  modalEmpresaRef!: NgbModalRef;
  empresaselecionada: any;
  formEmpresa!: FormGroup;
  mostrarOrigenDestino: boolean = false;
  private mostrarAvisoDisponibilidad: boolean = true;
  private omitirAlertaDisponibilidad: boolean = false;
  empresaId: any;
  administraciones: Administracion[] = [];

  estadisticas = {
  totalContratos: 0,
  contratosVigentes: 0,
  contratosVencidos: 0,
  disponibilidadSi: 0,
  disponibilidadNo: 0
};



  @ViewChild("inputCC") inputCC!: ElementRef;
  @ViewChild("inputCC") inputContratante!: ElementRef;
  @ViewChild("inputDireccionCon") inputDireccionCon!: ElementRef;
  @ViewChild("inputCiudadCon") inputCiudadCon!: ElementRef;
  @ViewChild("inputIdres") inputIdres!: ElementRef<HTMLInputElement>;
  @ViewChild("inputResponsable")
  inputResponsable!: ElementRef<HTMLInputElement>;
  @ViewChild("inputDiResponsable")
  inputDiResponsable!: ElementRef<HTMLInputElement>;
  @ViewChild("inputContratoNumero")
  inputContratoNumero!: ElementRef<HTMLInputElement>;
  @ViewChild("inputCuires") inputCuires!: ElementRef<HTMLInputElement>;
  @ViewChild("inputTelefono") inputTelefono!: ElementRef<HTMLInputElement>;
  @ViewChild("inputMailResponsable") inputMailResponsable!: ElementRef;
  @ViewChild("inputInicio") inputInicio!: ElementRef;
  @ViewChild("inputFin") inputFin!: ElementRef;
  @ViewChild("inputPasajeros") inputPasajeros!: ElementRef;
  @ViewChild("inputValor") inputValor!: ElementRef;
  @ViewChild("inputInicial") inputInicial!: ElementRef;
  @ViewChild("inputFinal") inputFinal!: ElementRef;
  @ViewChild('inputInicial', { read: ElementRef }) inputInicialRef!: ElementRef;
  @ViewChild('inputFinal', { read: ElementRef }) inputFinalRef!: ElementRef;
  @ViewChild("inputTipo") inputTipo!: ElementRef;
  @ViewChild("inputOrigenCont") inputOrigenCont!: ElementRef;
  @ViewChild("inputDestinoCont") inputDestinoCont!: ElementRef;
    @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  
  

  constructor(
    private objetoscontratosService: ObjetosContratosService,
    private router: Router,
    private empresasService: EmpresasService,
    private contratosService: ContratosService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private gpcGoogle: gpcGoogleService,
    private dataService: DataService,
    private administracionesServices: AdministracionService,
  ) {}

  ngOnInit() {
    this.setMinAndMaxDates();
    // Inicializar formulario de filtros y valores relacionados
    this.formPlanilla = this.fb.group({
      objeto: [[]],
      contratista: [null],
      finicial: [null],
      ffinal: [null],
    });
    this.hoy = this.formatDateForInput(new Date());
    this.minFechaFinal = this.minDate;
    this.formPlanilla.get('finicial')?.valueChanges.subscribe(() => this.actualizarMinFechaFinalFiltro());
    this.selectedEstado = "";
    //this.listarContratos();
    this.cargarObjetos();
    this.cargarEmpresas();
    this.cargarMunicipios();
    this.cargarDataAdmin();

    this.formContrato = this.fb.group({
      id: [""],
      numero: [null],
      cedula: [null],
      contratante: [null],
      direccion: [null],
      ciudad: [null],
      telefono: [null],
      mail: [null],
      inicio: [null],
      fin: [null],
      tipo: [null],
      idres: [null],
      origen: [null],
      destino: [null],
      responsable: [null],
      dirresponsble: [null],
      telres: [null],
      cuires: [null],
      mailresp: [null],
      pasajeros: [null],
      valor: [null],
      estado: [1],
      disponibilidad: [{ value: 0, disabled: true }],
    });

        this.formEmpresa = this.fb.group({
          nit: [""],
          digito: [null],
          nombre: [null],
          direccion: [null],
          ciudad: [null],
          telefono: [
            null,
            [
              Validators.min(1000000),
              Validators.max(9999999999),
              Validators.maxLength(10),
              Validators.pattern(/^\d{0,10}$/),
            ],
          ],
          celular: [
            null,
            [
              Validators.min(1000000),
              Validators.max(9999999999),
              Validators.maxLength(10),
              Validators.pattern(/^\d{0,10}$/),
            ],
          ],
          email: [null],
          observaciones: [null],
          eps: [false],
          arl: [false],
          afp: [false],
          ces: [false],
          ccf: [false],
          bancos: [false],
          transporte: [false],
          colegio: [false],
          cda: [false],
          taller: [false],
          eds: [false],
          contratista: [false],
          proveedor: [false],
          aseguradora: [false],
          almacen: [false],
          serviteca: [false],
          estado: [1],
        });
    

    if (this.fechaMaxima) {
      const fecha = new Date(this.fechaMaxima);
      const fechaFormatoInput = this.formatDateForInput(fecha);
      this.formPlanilla.patchValue({
        ffinal: fechaFormatoInput,
      });
    }

    this.formContrato.get('inicio')?.valueChanges.subscribe(() => {
    this.actualizarMinFechaFinal();
  });

  this.formContrato.get('tipo')?.valueChanges.subscribe((valorSeleccionado) => {
    const disponibilidadControl = this.formContrato.get('disponibilidad');
    this.mostrarAvisoDisponibilidad = true;

    if (valorSeleccionado === 2 || valorSeleccionado === 5) {
      disponibilidadControl?.enable();
      if (disponibilidadControl?.value === null || disponibilidadControl?.value === undefined) {
        disponibilidadControl?.setValue(0, { emitEvent: false });
      }
    } else {
      if (!this.editMode) {
        disponibilidadControl?.setValue(0, { emitEvent: false });
      }
      disponibilidadControl?.disable();
    }

    this.onDisponibilidadChange(
      disponibilidadControl?.value ?? 0,
      !this.omitirAlertaDisponibilidad
    );
  });

  this.formContrato.get('disponibilidad')?.valueChanges.subscribe(() => {
    this.actualizarVisibilidadOrigenDestino();
  });

  this.actualizarVisibilidadOrigenDestino();
  }

  private cargarEmpresas(): void {
    this.empresasService.getContratistas().subscribe({
      next: (data) => (this.empresas = data),
    });
  }

  private cargarObjetos(): void {
    this.objetoscontratosService.getObjetos().subscribe({
      next: (data) => (this.objetos = data),
    });
  }

  private setMinAndMaxDates(): void {
  // Obtener fecha actual en horario Colombia (GMT-5)
  const now = new Date();
  // Ajustar a Colombia restando 5 horas
  const colombiaOffsetMs = -5 * 60 * 60 * 1000;
  const colombiaDate = new Date(now.getTime() + colombiaOffsetMs);
  const year = colombiaDate.getUTCFullYear();
  const month = ("0" + (colombiaDate.getUTCMonth() + 1)).slice(-2);
  const day = ("0" + colombiaDate.getUTCDate()).slice(-2);
  const todayColombia = `${year}-${month}-${day}`;
  this.minDate = todayColombia;
  this.maxDate = todayColombia;
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => (this.municipios = data),
    });
  }

  listarContratos(): void {
    this.contratosService.getTodosLosContratos().subscribe({
      next: (data) => {
        if (Array.isArray(data)) {
         // console.log("Contratos cargados:", data);
          this.contratos = data;
          this.filteredTableItems = data;
        }
      },
      error: (err) => {
        console.error("Error al cargar contratos", err);
      },
    });
  }

  openModalContrato(content: any, id?: number): void {
    this.editMode = !!id;
    this.contratoSeleccionado = null;
    this.formContrato.reset();
    this.mostrarAvisoDisponibilidad = true;
    this.mostrarOrigenDestino = false;
    this.activePanelmodel = ["static-1"];

    if (id) {
      // 🔁 Modo edición
      this.contratosService.getContratoPorid(id).subscribe({
        next: (contrato) => {
          this.contratoSeleccionado = contrato.id;
          this.omitirAlertaDisponibilidad = true;

          if (contrato.inicio) contrato.inicio = this.formatearFecha(contrato.inicio);
          if (contrato.fin) contrato.fin = this.formatearFecha(contrato.fin);
          contrato.disponibilidad = this.normalizarDisponibilidad(contrato.disponibilidad);

          this.formContrato.patchValue(contrato);
          this.onDisponibilidadChange(
            this.formContrato.get("disponibilidad")?.value ?? 0,
            false
          );
          this.omitirAlertaDisponibilidad = false;

          this.modalContratoRef = this.modalService.open(content, {
            size: "xl",
            backdrop: "static",
            windowClass: "custom-modal-full-width",
          });

          // Limpiar empresa seleccionada al cerrar modal
          this.modalContratoRef.result.finally(() => {
            this.empresaSeleccionada = null;
          });
        },
        error: () => {
          this.omitirAlertaDisponibilidad = false;
          this.mostrarAlerta2("Error", "No se pudo cargar el contrato", "error");
        },
      });
    } else {
      // 🟢 Modo creación
      this.editMode = false;

      this.empresaMostrada =
        this.empresas.find((e) => `${e.nit}` === `${this.empresaSeleccionada}`) || null;

      if (this.empresaMostrada) {
        this.formContrato.patchValue({
          cedula: this.empresaMostrada.nit,
          contratante: this.empresaMostrada.nombre,
          direccion: this.empresaMostrada.direccion,
          ciudad: this.empresaMostrada.ciudad,
          telefono: this.empresaMostrada.celular,
          mail: this.empresaMostrada.email,
        });
      }

      this.onDisponibilidadChange(this.formContrato.get("disponibilidad")?.value ?? 0, false);

      this.modalContratoRef = this.modalService.open(content, {
        size: "xl",
        backdrop: "static",
       windowClass: 'modal-70-width'
      });

      // Limpiar empresa seleccionada al cerrar modal
      this.modalContratoRef.result.finally(() => {
        this.empresaSeleccionada = null;
      });
    }
  }

  abrirModal(content: any): void {
    this.modalContratoRef = this.modalService.open(content, {
      backdrop: "static",
      size: "lg", // o quítalo
      centered: true,
      windowClass: "w-100", // clase de Bootstrap
    });
  }

  guardarContrato(modalRef: NgbModalRef): void {
    this.validate = true;

  const tipoContrato = this.formContrato.get('tipo')?.value;
  const requiereRuta = this.requiereOrigenDestino();

let camposRequeridos = [
  {
    campo: "idres",
    mensaje: "el CC o NIT del responsable",
    ref: this.inputIdres,
  },
  {
    campo: "responsable",
    mensaje: "el nombre del responsable",
    ref: this.inputResponsable,
  },
  {
    campo: "dirresponsble",
    mensaje: "la dirección responsable",
    ref: this.inputDiResponsable,
  },
  { campo: "cuires", mensaje: "la ciudad", ref: this.inputCuires },
  {
    campo: "telres",
    mensaje: "el teléfono del responsable",
    ref: this.inputTelefono,
  },
 /*  {
    campo: "mailresp",
    mensaje: "el email del responsable",
    ref: this.inputMailResponsable,
  }, */
  { campo: "tipo", mensaje: "un objeto de contrato", ref: this.inputTipo },
  { campo: "inicio", mensaje: "la fecha de inicio", ref: this.inputInicio },
  { campo: "fin", mensaje: "la fecha de finalización", ref: this.inputFin },
  /* {
    campo: "pasajeros",
    mensaje: "el número de pasajeros",
    ref: this.inputPasajeros,
  },
  {
    campo: "valor",
    mensaje: "el valor del servicio",
    ref: this.inputValor,
  }, */
];

// Solo agregar origen y destino si el contrato lo requiere
if (requiereRuta) {
  camposRequeridos.push(
    { campo: "origen", mensaje: "el origen", ref: this.inputOrigenCont },
    { campo: "destino", mensaje: "el destino", ref: this.inputDestinoCont }
  );
}else{
this.formContrato.patchValue({
        origen: 0,
        destino:0 
           });

}

    for (const campo of camposRequeridos) {
      const valor = this.formContrato.get(campo.campo)?.value;
      if (!valor) {
        this.mostrarAlerta2(
          "Campo requerido",
          `Por favor, ingresa ${campo.mensaje}`,
          "info"
        );

        setTimeout(() => {
          requestAnimationFrame(() => {
            const input = campo.ref?.nativeElement;
            if (input) {
              input.scrollIntoView({ behavior: "smooth", block: "center" });
              input.focus();
              if (typeof input.value === "string") {
                input.setSelectionRange?.(
                  input.value.length,
                  input.value.length
                );
              }
            }
          });
        }, 200);

        return;
      }
    }

    // Construir datos
    const datosContrato: any = {
      ...this.formContrato.value,      
      estado: 1,
    };

    // Eliminar campos nulos que puedan generar errores
    Object.keys(datosContrato).forEach((key) => {
      if (datosContrato[key] === null) {
        delete datosContrato[key];
      }
    });

   // console.log("Datos a enviar:", datosContrato);
   // console.log("editMode: ", this.editMode);
   // console.log("contratoSeleccionado: ", this.contratoSeleccionado);

    if (this.editMode && this.formContrato.get('id')?.value ) {
      // 🔁 Editar contrato
    //  console.log("Editando contrato ID:", this.formContrato.get('id')?.value);
      this.contratosService
        .updateContratoPorId(this.formContrato.get('id')?.value, datosContrato)
        .subscribe({
          next: () => {
            modalRef.close();
            this.resetFormulario();
            this.mostrarAlerta2(
              "Éxito",
              "Contrato actualizado correctamente.",
              "success"
            );
            this.listarContratos();
          },
          error: (error) => {
            this.mostrarAlerta2(
              "Error",
              error.message || "Error al actualizar el contrato",
              "error"
            );
          },
        });
    } else {
      // ✅ Crear contrato
     // console.log("Creando nuevo contrato");
     // console.log("Datos enviados para creación:", datosContrato);
      this.contratosService.createContrato(datosContrato).subscribe({
        next: () => {
          modalRef.close();
          this.resetFormulario();
          this.mostrarAlerta2(
            "Éxito",
            "Contrato creado correctamente.",
            "success"
          );
          this.listarContratos();
        },
        error: (error) => {
          this.mostrarAlerta2(
            "Error",
            error.message || "Error al guardar el contrato",
            "error"
          );
        },
      });
    }
  }

  resetFormulario(): void {
    this.formContrato.reset();
    this.editMode = false;
    this.empresaSeleccionada = null;
    this.contratoSeleccionado = null;
    this.mostrarAvisoDisponibilidad = true;
    this.mostrarOrigenDestino = false;
  }

  // 🔢 Generador de número aleatorio de 5 dígitos único
  private generarNumeroAleatorio(): string {
    let numero = "";
    const digits = "0123456789";

    while (numero.length < 5) {
      const digit = digits[Math.floor(Math.random() * digits.length)];
      if (!numero.includes(digit) || numero.length >= 4) {
        numero += digit;
      }
    }

    return numero.padStart(5, "0");
  }

  avisoInactivarContrato(id: number): void {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el contrato?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then(({ isConfirmed }) => {
      if (!isConfirmed) return;

      this.contratosService.inactivateContrato(id).subscribe({
        next: ({ message }) => {
          Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: message || "Contrato inactivado correctamente.",
            confirmButtonText: "Aceptar",
          }).then(() => this.listarContratos());
        },
        error: ({ error }) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error?.message || "No se pudo inactivar el contrato.",
            confirmButtonText: "Aceptar",
          });
        },
      });
    });
  }

  filterData() {
    const search = this.searchText.toLowerCase();
    this.filteredTableItems = this.contratos.filter((item) =>
      (
        item.id?.toString().toLowerCase() +
        item.numero?.toString().toLowerCase() +
        item.cedula?.toString().toLowerCase() +
        item.contratante?.toString().toLowerCase()
      ).includes(search)
    );
    this.page1 = 1;
  }

  estadoMap: { [key: string]: string } = {
    VIGENTE: "badge badge-light-success",
    "POR VENCER": "badge badge-light-warning",
    VENCIDO: "badge badge-light-secondary",
  };

  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, usa gris
  }
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  formatearFecha(fecha: string): string {
  if (!fecha) return '';
  // Si es string ISO, parsear como UTC
  const date = new Date(fecha);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
  }

  private mostrarAlerta2(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  onDisponibilidadChange(valor: number | string, mostrarMensaje: boolean = true): void {
    const disponibilidad = this.normalizarDisponibilidad(valor);
    const tipo = Number(this.formContrato.get("tipo")?.value);
    if (
      disponibilidad === 1 &&
      (tipo === 2 || tipo === 5) &&
      mostrarMensaje &&
      this.mostrarAvisoDisponibilidad
    ) {
      this.mostrarAlerta2(
        "Disponibilidad total activa",
        "Si seleccionas “Sí”, las rutas no se habilitarán al momento de hacer el extracto (FUEC). Para activarlas, selecciona “No”.",
        "info"
      );
      this.mostrarAvisoDisponibilidad = false;
    }

    if (disponibilidad !== 1) {
      this.mostrarAvisoDisponibilidad = true;
    }

    this.actualizarVisibilidadOrigenDestino();
  }

  private permiteDisponibilidadEnTipo(): boolean {
    const tipo = Number(this.formContrato.get("tipo")?.value);
    return tipo === 2 || tipo === 5;
  }

  private normalizarDisponibilidad(valor: any): number {
    if (valor === true || valor === 1 || valor === "1") {
      return 1;
    }

    if (typeof valor === "string") {
      const valorNormalizado = valor.trim().toUpperCase();
      if (valorNormalizado === "SI" || valorNormalizado === "SÍ") {
        return 1;
      }
    }

    return 0;
  }

  private requiereOrigenDestino(): boolean {
    const tipo = Number(this.formContrato.get("tipo")?.value);
    return tipo === 4;
  }

  private actualizarVisibilidadOrigenDestino(): void {
    this.mostrarOrigenDestino = this.requiereOrigenDestino();

    if (!this.mostrarOrigenDestino) {
      this.formContrato.patchValue(
        {
          origen: null,
          destino: null,
        },
        { emitEvent: false }
      );
    }
  }

  mostrarEmpresaSeleccionada(): void {
    this.empresaMostrada =
      this.empresas.find((e) => e.nit === this.empresaSeleccionada) || null;

    this.contratoMostrado = null;
    this.contratoSeleccionado = null;
//    console.log(this.empresaMostrada);
    if (this.empresaMostrada) {
      this.formContrato.patchValue({
        cedula: this.empresaMostrada.nit,
        contratante: this.empresaMostrada.nombre,
        direccion: this.empresaMostrada.direccion,
        ciudad: this.empresaMostrada.municipio.MUNICIPIO, // corregido
        telefono: this.empresaMostrada.celular,
        mail: this.empresaMostrada.email,
      });
      //this.editMode = true;
    }
  }

  trasladarDatosEmpresa() {
    if (this.empresaMostrada && this.formContrato) {
      const contrato = this.formContrato.value;
      this.formContrato.patchValue({
        idres: contrato.cedula,
        responsable: contrato.contratante,
        dirresponsble: contrato.direccion,
        cuires: contrato.ciudad,
        telres: contrato.telefono,
        mailresp: contrato.mail
      });
      this.activePanelmodel = ["static-2"];
    }
  }

  mensajeBusqueda!: string;

  consultarContratos(): void {

  const objetoRaw = this.formPlanilla?.value.objeto;

  const objeto = Array.isArray(objetoRaw)
    ? objetoRaw.filter(item =>
        item !== null &&
        item !== undefined &&
        item !== '')
    : objetoRaw;

  const contratista = this.formPlanilla?.value.contratista?.toString().trim();
  const finicial = this.formPlanilla?.value.finicial?.toString().trim();
  const ffinal = this.formPlanilla?.value.ffinal?.toString().trim();

  const tieneObjeto =
    Array.isArray(objeto)
      ? objeto.length > 0
      : !!objeto;

  const tieneContratista = !!contratista;
  const tieneFechaInicial = !!finicial;
  const tieneFechaFinal = !!ffinal;

  // Debe existir al menos un filtro
  if (
    !tieneObjeto &&
    !tieneContratista &&
    !tieneFechaInicial &&
    !tieneFechaFinal
  ) {
    this.filteredTableItems = [];
    this.mensajeBusqueda =
      'Debes proporcionar al menos un filtro para buscar.';
    return;
  }

  // Ambas fechas son obligatorias si se usa rango
  if (
    (tieneFechaInicial && !tieneFechaFinal) ||
    (!tieneFechaInicial && tieneFechaFinal)
  ) {
    this.mostrarAlerta2(
      'Campo requerido',
      'Debe seleccionar fecha inicial y fecha final.',
      'info'
    );
    return;
  }

  // Validar rango
  if (
    tieneFechaInicial &&
    tieneFechaFinal &&
    new Date(finicial) > new Date(ffinal)
  ) {
    this.mostrarAlerta2(
      'Rango inválido',
      'La fecha inicial no puede ser mayor que la fecha final.',
      'info'
    );
    return;
  }

  this.contratosService
    .buscarContratosPorFiltros(
      objeto,
      contratista,
      finicial,
      ffinal
    )
    .subscribe({
      next: (resp) => {
        this.filteredTableItems = Array.isArray(resp) ? resp : [];
        this.calcularEstadisticas();
        this.mensajeBusqueda =
          this.filteredTableItems.length === 0
            ? 'No se encontraron contratos para los filtros seleccionados.'
            : '';

        this.page1 = 1;
      },
      error: (err) => {
        console.error(
          'Error al buscar contratos:',
          err.error?.message || err
        );

        this.filteredTableItems = [];
        this.mensajeBusqueda =
          err.error?.message ||
          'Ocurrió un error al realizar la búsqueda.';
      }
    });
}

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const fechaHora = `${fecha} - ${hora}`;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100);

    doc.textWithLink(
      "Generado desde Admin SEAF – INDESOFT SAS",
      150,
      pageHeight - 12,
      {
        url: "https://indesofsas.com",
        align: "center",
      }
    );

    doc.text(fechaHora, 10, pageHeight - 5);
    doc.text(`Página ${currentPage} de ${totalPages}`, 285, pageHeight - 5, {
      align: "right",
    });
  }

  async addQRCode(
    doc: jsPDF,
    data: string,
    x: number,
    y: number,
    size: number = 20
  ) {
    try {
      const qrDataUrl = await QRCode.toDataURL(data, {
        width: size,
        margin: 1,
      });
      doc.addImage(qrDataUrl, "PNG", x, y, size, size);
    } catch (err) {
      console.error("Error al generar QR:", err);
    }
  }

  GenerarPdfTodosContratos(): void {
    const contratos = this.filteredTableItems;
    if (!contratos || contratos.length === 0) {
      this.mostrarAlerta2(
        "Sin datos",
        "No hay contratos para generar el PDF",
        "info"
      );
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [300, 216],
    });

    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 10;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setFillColor(230, 230, 230);
    doc.rect(10, y, 280, 10, "FD");
    doc.setTextColor(0);
    doc.text("LISTADO DE CONTRATOS", 150, y + 6.5, { align: "center" });
    y += 12;

    const columnas = [
      { label: "CONTRATO #", key: "numero", width: 25 },
      { label: "NIT/CC", key: "cedula", width: 30 },
      { label: "CONTRATANTE", key: "contratante", width: 45 },
      { label: "INICIO", key: "inicio", width: 25 },
      { label: "FINAL", key: "fin", width: 25 },
      { label: "OBJETO", key: "tipo", width: 55 },
      { label: "RESPONSABLE", key: "responsable", width: 45 },
      { label: "DISPONIBILIDAD", key: "disponibilidad", width: 30 },
    ];

    const startX = 10;
    const lineHeight = 6; // 🔹 Aumentado el espacio entre líneas

    const drawHeader = () => {
      let x = startX;
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      for (const col of columnas) {
        doc.setFillColor(200, 200, 200);
        doc.rect(x, y, col.width, lineHeight, "FD");
        doc.setTextColor(0);
        doc.text(col.label, x + 2, y + 4.5); // Añadido padding superior
        x += col.width;
      }
      y += lineHeight;
    };

    drawHeader();

    doc.setFont("helvetica", "normal");

    contratos.forEach((contrato) => {
      let x = startX;
      let maxCellHeight = lineHeight;

      const cellLines = columnas.map((col) => {
        let texto = contrato[col.key];
        if (col.key === "disponibilidad") {
          texto = contrato.disponibilidad ?? "NO";
        }
        if (texto === null || texto === undefined) texto = "N/A";
        const wrappedText = doc.splitTextToSize(String(texto), col.width - 4); // 4mm de padding lateral
        const cellHeight = wrappedText.length * lineHeight;
        maxCellHeight = Math.max(maxCellHeight, cellHeight);
        return wrappedText;
      });

      if (y + maxCellHeight > pageHeight - 20) {
        doc.addPage();
        y = 20;
        drawHeader();
      }

      x = startX;
      for (let i = 0; i < columnas.length; i++) {
        const col = columnas[i];
        const lines = cellLines[i];

        doc.setFillColor(255, 255, 255);
        doc.rect(x, y, col.width, maxCellHeight, "FD");

        lines.forEach((line, lineIndex) => {
          const lineY = y + 4 + lineIndex * lineHeight; // padding arriba + interlineado
          doc.text(line, x + 2, lineY);
        });

        x += col.width;
      }

      y += maxCellHeight;
    });

    this.addFooter(doc, 1, 1);

    doc.save("Listado_contratos.pdf");
  }

addHeader(doc: jsPDF, title: string) {
  const pageWidth = 210;       // Ancho total en mm (Letter)
  const marginLeft = 5;
  const marginRight = 5;
  const rectY = 3;
  const headerHeight = 20;
  const rectWidth = pageWidth - marginLeft - marginRight;

  // Dibujar el rectángulo
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.5);
  doc.rect(marginLeft, rectY, rectWidth, headerHeight);

  // Título centrado
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);

  const text = String(title); // Asegurarse de que es string
  const textWidth = doc.getTextWidth(text);
  const centerX = marginLeft + (rectWidth - textWidth) / 2;
  const textY = rectY + 12;

  doc.text(text, centerX, textY);
}


  async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>
  ) {
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    const getImageBase64Safe = async (url: string | null) => {
      if (!url) return null;
      try {
        return await gpcGoogle.getImageBase64(url);
      } catch {
        return null;
      }
    };

    const imageKeys = Object.entries(imageMap);
    const signedUrls = await Promise.all(
      imageKeys.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    const base64Images = await Promise.all(
      signedUrls.map((url) => getImageBase64Safe(url))
    );

    base64Images.forEach((base64, idx) => {
      const { x, y, w, h } = imageKeys[idx][1];
      if (base64) {
        doc.addImage(base64, "JPG", x, y, w, h, undefined, "FAST");
      } else {
        // Mostrar texto si no se pudo cargar la imagen
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("SIN SOPORTE CARGADO", x + 2, y + h / 2, { maxWidth: w });
      }
    });
  }
  addFooterPlanilla(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    const fechaHora = `${fecha} - ${hora}`;

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);

    // Línea de pie centrada
    // Enlace clicable en el centro
    const linkText = "Generado desde Admin SEAF – INDESOFT SAS";
    doc.textWithLink(linkText, 115, pageHeight - 12, {
      url: "https://indesoftsas.com",
      align: "center",
    });

    // Fecha y hora a la izquierda
    doc.text(`${fechaHora}`, 10, pageHeight - 5);

    // Número de página a la derecha
    doc.text(`Página ${currentPage} de ${totalPages}`, 200, pageHeight - 5, {
      align: "right",
    });
  }

  GenerarPdfDatosContrato(numero: number): void {
    this.contratosService.getContratoBypdfplantilla(numero).subscribe({
      next: async (contrato: any) => {
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "letter",
        });

        const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";
    const imgLogo = "../../../../../assets/images/hoja_vida/logo.png";

    this.addHeader(doc, 'CONTRATO');
    await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 160, y: 5, w: 40, h: 14 },
      logo: { path: `${this.empresaId}/logos/logo.png`, x: 10, y: 9, w: 40, h: 8 }
    },);

    Promise.all([
      this.getBase64Image(imgUrl),
      //this.getBase64Image(imgLogo)
    ]).then(([bannerBase64]) => {

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);

        let y = 32;
        const leftX = 10;
        const pageWidth = doc.internal.pageSize.getWidth();
        const fullWidth = pageWidth - leftX * 2;
        const rowHeight = 6;

        const drawSectionTitle = (text: string) => {
          doc.setFillColor(230, 230, 230); // Gris claro
          doc.rect(leftX, y, fullWidth, rowHeight, "F");
          doc.setTextColor(0);
          doc.setFont("helvetica", "bold");
          doc.text(text, pageWidth / 2, y + 4, { align: "center" });
          y += rowHeight;
        };

        const drawRow = (leftText: string, rightText: string) => {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.setDrawColor(0);
          doc.rect(leftX, y, fullWidth, rowHeight);
          doc.text(leftText, leftX + 2, y + 4);
          doc.text(rightText, leftX + fullWidth / 2 + 2, y + 4);
          y += rowHeight;
        };

        // 🔷 EMPRESA TRANSPORTADORA
        drawSectionTitle("EMPRESA TRANSPORTADORA");

        drawRow(
          `NOMBRE: ${contrato.contratante ?? "N/A"}`,
          `NIT: ${contrato.cedula ?? "N/A"}`
        );

        drawRow(
          `TELÉFONO: ${contrato.telefono ?? "N/A"}`,
          `DIRECCIÓN: ${contrato.direccion ?? "N/A"}`
        );

        // 🔷 DATOS DEL CONTRATANTE
        drawSectionTitle("DATOS DEL CONTRATANTE");

        drawRow(
          `NOMBRE COMPLETO: ${contrato.responsable ?? "N/A"}`,
          `CÉDULA/NIT: ${contrato.idres ?? "N/A"}`
        );

        drawRow(
          `TELÉFONO: ${contrato.telres ?? "N/A"}`,
          `DIRECCIÓN: ${contrato.dirresponsble ?? "N/A"}`
        );

        doc.setFontSize(8.5);
        doc.setFont("helvetica", "normal");

        const textoLegal = `Los arriba citados, hemos convenido celebrar el CONTRATO DE PRESTACION DE SERVICIO DE TRANSPORTE ESPECIAL DE PASAJEROS que se especifica a continuación, en cumplimiento al artículo 7 del Decreto 431 del 2017, que se regirá por las normas civiles, comerciales y demás disposiciones concordantes y complementarias y en lo no regulado por estas, por lo pactado en las siguientes cláusulas. CLAUSULA PRIMERA: OBJETO DEL CONTRATO – LA TRANSPORTADORA prestará al CONTRATANTE el servicio de transporte especial de pasajeros, desde los sitios de abordaje hasta los sitios de llegada previamente acordados con el CONTRATISTA, así:`;

        const textoLegalLines = doc.splitTextToSize(textoLegal, fullWidth - 4);
        doc.text(textoLegalLines, leftX + 0, y + 4);
        y += textoLegalLines.length * rowHeight + 2;

        // Ahora los helpers reciben y devuelven la nueva posición, para que puedas controlar dónde se dibujan:

        // Helpers independientes para mover las tablas donde quieras
        const drawSectionTitle2 = (
          doc: jsPDF,
          text: string,
          leftX: number,
          y: number,
          fullWidth: number,
          rowHeight: number,
          pageWidth: number
        ): number => {
          doc.setFillColor(230, 230, 230); // Gris claro
          doc.rect(leftX, y, fullWidth, rowHeight, "F");
          doc.setTextColor(0);
          doc.setFont("helvetica", "bold");
          doc.text(text, pageWidth / 2, y + 4, { align: "center" });
          return y + rowHeight;
        };

        const drawRow2 = (
          doc: jsPDF,
          leftText: string,
          rightText: string,
          leftX: number,
          y: number,
          fullWidth: number,
          rowHeight: number
        ): number => {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.setDrawColor(0);
          doc.rect(leftX, y, fullWidth, rowHeight);
          doc.text(leftText, leftX + 2, y + 4);
          doc.text(rightText, leftX + fullWidth / 2 + 2, y + 4);
          return y + rowHeight;
        };

        const drawTripleRow = (
          doc: jsPDF,
          col1: string,
          col2: string,
          col3: string,
          leftX: number,
          y: number,
          fullWidth: number,
          rowHeight: number
        ): number => {
          const colWidth = fullWidth / 3;
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.setDrawColor(0);

          // Dibujar rectángulos
          doc.rect(leftX, y, colWidth, rowHeight); // Primera columna
          doc.rect(leftX + colWidth, y, colWidth, rowHeight); // Segunda
          doc.rect(leftX + colWidth * 2, y, colWidth, rowHeight); // Tercera

          // Agregar textos
          doc.text(col1, leftX + 2, y + 4);
          doc.text(col2, leftX + colWidth + 2, y + 4);
          doc.text(col3, leftX + colWidth * 2 + 2, y + 4);

          return y + rowHeight;
        };

        const drawSingleRow = (
          doc: jsPDF,
          text: string,
          leftX: number,
          y: number,
          fullWidth: number,
          rowHeight: number
        ): number => {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.setDrawColor(0);

          doc.rect(leftX, y, fullWidth, rowHeight);
          doc.text(text, leftX + 2, y + 4);

          return y + rowHeight;
        };

        // Ejemplo de uso: puedes elegir la posición (y) de cada tabla
        // Después del bloque de texto legal
        y += -12; // un pequeño espacio

        // ORIGEN Y DESTINO
        y = drawRow2(
          doc,
          `ORIGEN: ${contrato.municipioOrigen.MUNICIPIO ?? "N/A"}`,
          `DESTINO: ${contrato.municipioDestino.MUNICIPIO ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        // TÍTULO
        y = drawSectionTitle2(
          doc,
          "RESPONSABLE POR LA EMPRESA TRANSPORTADORA",
          leftX,
          y,
          fullWidth,
          rowHeight,
          pageWidth
        );

        // FILAS
        y = drawRow2(
          doc,
          `NOMBRE: ${contrato.responsable ?? "N/A"}`,
          `CÉDULA: ${contrato.idres ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        y = drawRow2(
          doc,
          `TELEFONO: ${contrato.telres ?? "N/A"}`,
          `DIRECCION: ${contrato.dirresponsble ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        y = drawSectionTitle2(
          doc,
          "DATOS DEL CONDUCTOR Y VEHICULO",
          leftX,
          y,
          fullWidth,
          rowHeight,
          pageWidth
        );
        const planilla = contrato.planillas?.[0]; // ⬅️ obtener la primera planilla (o undefined si no hay)

        // FILAS
        y = drawRow2(
          doc,
          `NOMBRE CONDUCTOR 1: ${planilla?.conductor ?? "N/A"}`,
          `CÉDULA: ${planilla?.cedula ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        y = drawRow2(
          doc,
          `NOMBRE CONDUCTOR 2: ${planilla?.conductor1 ?? "N/A"}`,
          `CÉDULA: ${planilla?.cedula1 ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        y = drawTripleRow(
          doc,
          `PLACA: ${planilla?.placa ?? "N/A"}`,
          `MODELO: ${planilla?.modelo ?? "N/A"}`,
          `N° INTERNO VEHICULO: ${planilla?.interno ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        y = drawSingleRow(
          doc,
          `DESCRIPCIÓN DE LA RUTA: ${planilla?.ruta ?? "N/A"}`,
          leftX,
          y,
          fullWidth,
          rowHeight
        );

        doc.setFontSize(8.5);
        doc.setFont("helvetica", "normal");

        const textoLegal2 = `CLAUSULA SEGUNDA: DURACION Y PRORROGAS DEL CONTRATO: El término de duración de este contrato es el necesario para el transporte de las personas y tendrá vigencia mientras se ejecute el contrato de transporte, pero podrá extenderse a otros servicios que se soliciten con posterioridad. CLAUSULA TERCERA: OBLIGACIONES DE LA EMPRESA TRANSPORTADORA:  1. LA TRANSPORTADORA prestará el servicio de transporte público especial de pasajeros, disponiendo los vehículos adecuados, en buen estado técnico – mecánico y de presentación, que sean requeridos para cubrir las rutas previamente señaladas.  2.  Verificar que los vehículos con los cuáles se presta el servicio, posean toda la documentación y seguros que exija la ley, para cubrir los riesgos de la ejecución del contrato de transporte.  3. Cada vehículo debe disponer de comunicación bidireccional.   4. LA TRANSPORTADORA se ciñe a las disposiciones legales en materia de transporte especial de pasajeros y las Autoridades respectivas y atenderá las situaciones que lleguen a presentarse por infracciones a las disposiciones legales o reglamentarias de tránsito y transporte.  CLAUSULA CUARTA: OBLIGACIONES DEL CONTRATANTE: EL CONTRATANTE se compromete a:    1. Cancelar total y oportunamente el valor pactado del servicio.   2. Informar con anterioridad no menor de 24 horas, cualquier cambio en el recorrido o los horarios definidos.   3. Comunicar a la empresa TRANSPORTADORA, cualquier falla o anomalía presentada en el servicio.   4. Velar porque los pasajeros tengan un trato respetuoso y adecuado con el conductor.   5. Responder por los daños causados al vehículo por los pasajeros, de lo cual el conductor informará inmediatamente al CONTRATANTE, dejando constancia y la anotación respetiva.   6. Hacerse responsable de su propio equipaje.   CLAUSULA QUINTA: VALOR DEL CONTRATO Y FORMA DE PAGO: El costo del transporte contratado será de ocho millones quinientos mil pesos M/L ($8.500.000) que se pagará de la siguiente manera: De contado, consignado a la cuenta de ahorros Bancolombia # 55100003939 a nombre de LA PUNTUALIDAD TRANSPORTE ESPECIAL S.A.S. y éste será cancelado antes de la prestación del servicio.   Si se requieren transportes adicionales se acordará directamente con la empresa, y se dejará registro de ello, sin necesidad de un nuevo contrato. CLAUSULA SEXTA: PENA PECUNIARIA: En caso de incumplimiento de cualquiera de las partes de cualquiera de las obligaciones principales de este contrato, la parte incumplida pagará a la otra una suma equivalente al quince por ciento (15%) del valor del contrato, suma que se considera como pago parcial por los daños y perjuicios causados. CLAUSULA SEPTIMA:  CESION: Los derechos y obligaciones que asume LA TRANSPORTADORA mediante el presente contrato, no podrán ser cedidos en todo o en parte a una persona natural o jurídica, nacional o extranjera, sin autorización previa y escrita del TRANSPORTADOR, pudiendo este reservarse las razones que tenga para negarla. El CONTRATANTE autoriza expresamente a que se realicen los convenios de colaboración empresarial que sean necesarios para cumplir con el objeto y obligaciones del presente contrato. CLAUSULA OCTAVA: FUERZA MAYOR O CASO FORTUITO: LA TRANSPORTADORA no será responsable ni se considerará que ha incurrido en incumplimiento de sus obligaciones por cualquier falla o deficiencia en la prestación de sus servicios, si se presentare durante su ejecución circunstancias de fuerza mayor, caso fortuito u otros hechos fuera de su control, de lo cual entregará la exposición de motivos correspondientes. CLAUSULA NOVENA: SUJECION A LA LEY COLOMBIANA: Para cualquier efecto, este contrato se someterá a la ley colombiana y ante las Autoridades legales preestablecidas.   CLAUSULA DECIMA: CAUSALES DE TERMINACION DEL CONTRATO: El contrato podrá darse por terminado bajo las siguientes circunstancias.   1. Por expiración del plazo o cumplimiento del servicio contratado. 2. Por mutuo acuerdo entre las partes contratantes.   3. Unilateralmente por cualquiera de las partes, en caso de incumplimiento por la otra parte, de cualquiera de las obligaciones principales establecidas en el contrato.   4. Por ejecución del servicio contratado, en los casos de transporte ocasional.    CLAUSULA DECIMA PRIMERA: INTERPRETACION DE SITUACIONES: Si se admitieren, toleraren o presentasen hechos o situaciones que difieran de lo convenido en el presente contrato, no por eso se entenderá revocación, modificación o novación alguna del mismo, salvo acuerdo expreso escrito por las partes.`;

        const textoLegalLines2 = doc.splitTextToSize(
          textoLegal2,
          fullWidth - 4
        );
        doc.text(textoLegalLines2, leftX + 0, y + 4);
        y += textoLegalLines2.length * rowHeight + 2;

        // Puedes cambiar el valor inicial de y o el orden de los llamados para mover las tablas donde quieras
        // Así puedes mover la posición de los cuadros fácilmente cambiando el valor de y

        // 💾 Guardar

        this.addFooterPlanilla(doc, 1, 1);

        doc.addPage();
        y = 32;

        this.addHeader(doc, contrato.numero);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);

        doc.setFontSize(8.5);
        doc.setFont("helvetica", "normal");

        const textoLegal3 = `CLAUSULA DECIMA SEGUNDA: SUSTITUCION Y MANIFESTACIONES: El presente contrato sustituye íntegramente a cualquier otro acuerdo o contrato suscrito anteriormente por las mismas partes. EL CONTRATANTE manifiesta que conoce, entiende y acepta el contenido de cada una de las cláusulas del presente contrato y lo suscribe luego de leído y en señal de aprobación.`;

const textoLegalLines3 = doc.splitTextToSize(textoLegal3, fullWidth - 4);
doc.text(textoLegalLines3, leftX + 0, y + 4);
y += textoLegalLines3.length * rowHeight + 2;

// Ciudad y fecha
const fechaTexto = `Ciudad y Fecha: Medellín, día veintitrés (23) mes junio año 2024.`;
doc.setFont("helvetica", "normal");
doc.setFontSize(9);
doc.text(fechaTexto, leftX, y + 10);
y += 14;

// Función para dibujar las firmas
const drawFirmas = () => {
  const firmaY = y + 20;
  const colWidth = pageWidth / 2;
  const leftColX = leftX;
  const rightColX = pageWidth / 2;

  const nombreTransportadora = contrato.responsable ?? "N/A";
  const cedulaTransportadora = contrato.idres ?? "N/A";
  const nombreContratante = contrato.contratante ?? "N/A";
  const cedulaContratante = contrato.cedula ?? "N/A";

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);

  // Firma izquierda - EMPRESA TRANSPORTADORA
  doc.line(leftColX + 20, firmaY, leftColX + colWidth - 20, firmaY);
  doc.text(nombreTransportadora, leftColX + colWidth / 2, firmaY + 5, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.text("Por LA EMPRESA TRANSPORTADORA", leftColX + colWidth / 2, firmaY + 10, { align: "center" });
  doc.text(`C.C. ${cedulaTransportadora}`, leftColX + colWidth / 2, firmaY + 15, { align: "center" });

  // Firma derecha - CONTRATANTE
  doc.setFont("helvetica", "bold");
  doc.line(rightColX + 20, firmaY, rightColX + colWidth - 20, firmaY);
  doc.text(nombreContratante, rightColX + colWidth / 2, firmaY + 5, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.text("Por EL CONTRATANTE", rightColX + colWidth / 2, firmaY + 10, { align: "center" });
  doc.text(`C.C./NIT. ${cedulaContratante}`, rightColX + colWidth / 2, firmaY + 15, { align: "center" });

  y = firmaY + 25;
};

// Dibujar las firmas
drawFirmas();


        // Footer de la segunda página
        this.addFooterPlanilla(doc, 2, 2);

        // ✅ Guardar al final
        doc.save(`Contrato_${contrato.numero}.pdf`);
      },
    )},
      error: (err) => {
        console.error("Error al obtener contrato:", err);
        this.mostrarAlerta2(
          "Error",
          "No se pudo generar el PDF del contrato",
          "error"
        );
      },
    });
  }

  actualizarMinFechaFinal(): void {
    const inicio = this.formContrato.get("inicio")?.value;

    if (inicio) {
      const fecha = new Date(inicio);
      fecha.setDate(fecha.getDate() + 1); // mínimo un día después
      this.fechaMinimaFinal = this.formatDateForInput(fecha);

      const fin = this.formContrato.get("fin")?.value;
      if (fin && new Date(fin) <= new Date(inicio)) {
        this.formContrato.get("fin")?.setValue(null);
      }
    } else {
      const hoy = new Date();
      this.fechaMinimaFinal = this.formatDateForInput(hoy);

      const fin = this.formContrato.get("fin")?.value;
      if (fin && new Date(fin) < hoy) {
        this.formContrato.get("fin")?.setValue(null);
      }
    }
  }

  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  actualizarMinFechaFinalFiltro(): void {
    const finicial = this.formPlanilla?.get('finicial')?.value;

    if (finicial) {
      const fecha = new Date(finicial);
      fecha.setDate(fecha.getDate() + 1); // mínimo un día después
      this.minFechaFinal = this.formatDateForInput(fecha);

      const ffinal = this.formPlanilla.get('ffinal')?.value;
      if (ffinal && new Date(ffinal) < new Date(finicial)) {
        this.formPlanilla.get('ffinal')?.setValue(null);
      }
    } else {
      const hoy = new Date();
      this.minFechaFinal = this.formatDateForInput(hoy);
    }
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formEmpresa.value };

    // Validación de correo
    const email = datos.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      this.mostrarAlerta(
        "Email inválido",
        "Correo no válido. Ej: usuario@dominio.com",
        "info"
      );
      return;
    }

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
      {
        campo: "nit",
        mensaje: "Por favor, ingresa un número de documento",
        ref: this.inputNit,
      },
      {
        campo: "digito",
        mensaje: "Por favor, ingresa un dígito de verificación",
        ref: this.inputCodigo,
      },
      {
        campo: "nombre",
        mensaje: "Por favor, ingresa un nombre",
        ref: this.inputNombre,
      },
      {
        campo: "direccion",
        mensaje: "Por favor, ingresa una dirección",
        ref: this.inputDireccion,
      },
      {
        campo: "ciudad",
        mensaje: "Por favor, ingresa una ciudad",
        ref: this.inputCiudad,
      },
      {
        campo: "celular",
        mensaje: "Por favor, ingresa un número de celular",
        ref: this.inputCelular,
      },
      /* {
        campo: "email",
        mensaje: "Por favor, ingresa un correo electrónico",
        ref: this.inputEmail,
      }, */
    ];

    for (const { campo, mensaje, ref } of camposObligatorios) {
      const valor = this.formEmpresa.get(campo)?.value;
      
      // Para el campo digito, aceptar 0 como válido
      if (campo === 'digito') {
        if (valor === null || valor === undefined || valor === '') {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      } else {
        if (!valor) {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      }
    }


    // Convertir checkboxes a 1/0
    const checkboxKeys = [
      "eps",
      "arl",
      "afp",
      "ces",
      "ccf",
      "bancos",
      "transporte",
      "colegio",
      "cda",
      "taller",
      "eds",
      "contratista",
      "proveedor",
      "aseguradora",
      "almacen",
      "serviteca",
    ];
    checkboxKeys.forEach((k) => (datos[k] = datos[k] ? 1 : 0));

    datos.estado = 1; // Activar empresa al guardar
    datos.contratista = 1; // Marcar como contratista

    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        this.empresasService.getContratistas().subscribe({
          next: (data) => {
            this.empresas = data;
            this.empresaSeleccionada = empresaCreada.nit;
            this.mostrarEmpresaSeleccionada();
          },
          error: (err) => {
            console.error("Error al actualizar contratistas:", err);
          },
        });

        Swal.fire("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar la empresa", "error");
      },
    });
  }

    getBase64Image(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("No context");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
    });
  }

    private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
        this.empresaId = this.administraciones[0].nit;
       // console.log(this.empresaId);
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }
    private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  // Formatea fecha ISO a DD/MM/YYYY en Colombia (GMT-5) sin perder el día por conversión de zona horaria
formatoFechaColombia(fechaIso: string): string {
  if (!fechaIso) return '';
  // Parse as UTC
  const date = new Date(fechaIso);
  // Colombia offset: -5 hours
  const colombiaOffsetMs = -5 * 60 * 60 * 1000;
  // Ajustar a Colombia sumando el offset
  const colombiaDate = new Date(date.getTime() + colombiaOffsetMs);
  const dd = String(colombiaDate.getUTCDate()).padStart(2, '0');
  const mm = String(colombiaDate.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = colombiaDate.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

  // ✅ Selecciona el rango dinámicamente según el botón presionado
  seleccionarRango(
    rango: "dia" | "semana" | "mes" | "trimestre" | "semestre" | "anio"
  ): void {
    const hoy = new Date(); // 📅 Fecha actual
    let diasARestar = 0;

    switch (rango) {
      case "dia":
        diasARestar = 1;
        break;
      case "semana":
        diasARestar = 7;
        break;
      case "mes":
        diasARestar = 30;
        break;
      case "trimestre":
        diasARestar = 90;
        break;
      case "semestre":
        diasARestar = 180;
        break;
      case "anio":
        diasARestar = 365;
        break;
    }

    const finicial = this.restarDias(hoy, diasARestar);
    const fechaInicioStr = this.formatoFecha(finicial);
    const fechaFinStr = this.formatoFecha(hoy);

    this.minFechaFinal = fechaInicioStr;

    this.formPlanilla.patchValue({
      finicial: fechaInicioStr,
      ffinal: fechaFinStr,
    });
  }

    formatoFecha(fecha: Date): string {
    return fecha.toISOString().split("T")[0];
  }

   // ✅ Resta días exactos a una fecha
  restarDias(fecha: Date, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - dias);
    return nuevaFecha;
  }
  
limpiarFiltros(): void {

  this.formPlanilla.reset();

  // Si objeto es un multiselect
  this.formPlanilla.patchValue({
    objeto: []
  }, { emitEvent: false });

  // Limpiar resultados
  this.filteredTableItems = [];

  // Limpiar mensajes
  this.mensajeBusqueda = '';

  // Reiniciar paginación
  this.page1 = 1;

}

calcularEstadisticas(): void {

  const hoy = new Date();

  this.estadisticas.totalContratos = this.filteredTableItems.length;

  this.estadisticas.contratosVigentes =
    this.filteredTableItems.filter(c =>
      new Date(c.fin) >= hoy
    ).length;

  this.estadisticas.contratosVencidos =
    this.filteredTableItems.filter(c =>
      new Date(c.fin) < hoy
    ).length;

  this.estadisticas.disponibilidadSi =
    this.filteredTableItems.filter(c =>
      Number(c.disponibilidad) === 1
    ).length;

  this.estadisticas.disponibilidadNo =
    this.filteredTableItems.filter(c =>
      Number(c.disponibilidad) === 0
    ).length;
}
  
}